import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";

const RecordProviderContracts = (props: { rnc: string }) => {
    const { rnc } = props;
    const [records, setRecords] = useState<any[]>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`DGII/ProviderContracts/${rnc}`);
            if (response.status === 200) {
                const data = response.data;
                if (Array.isArray(data)) {
                    setRecords(data);
                } else if (data && Array.isArray(data.data)) {
                    setRecords(data.data);
                }
            }
        } catch (error) {
            // silent fail — external data is supplementary
        }
    };

    useEffect(() => {
        if (rnc) bindRecords();
    }, [rnc]);

    if (records.length === 0) return null;

    return (
        <Card className="my-4">
            <Card.Header className="display-4">
                {t("Contratos con el Estado")}
            </Card.Header>
            <Card.Body className="p-3">
                <div className="table-responsive">
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th>{t("Institución")}</th>
                                <th>{t("Monto")}</th>
                                <th>{t("Fecha")}</th>
                                <th>{t("Descripción")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((item: any, index: number) => (
                                <tr key={index}>
                                    <td>{item.institution ?? item.institucion ?? item.nombre_institucion ?? "-"}</td>
                                    <td>{item.amount ?? item.monto ?? "-"}</td>
                                    <td>{item.date ?? item.fecha ?? "-"}</td>
                                    <td>{item.description ?? item.descripcion ?? item.objeto ?? "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default RecordProviderContracts;
